import { Grid, Link, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';
import { appUrls } from 'shared/components/MobileApps/MobileApps.constants';

import { CollapseSection } from '../CollapseSection/CollapseSection';
import { ReactComponent as AppleStoreLogo } from './assets/appleStoreLogo.svg';
import { ReactComponent as AppleStoreQR } from './assets/appleStoreQR.svg';
import { ReactComponent as GooglePlayLogo } from './assets/googlePlayLogo.svg';
import { ReactComponent as GooglePlayQR } from './assets/googlePlayQR.svg';
import { messages } from './MobileAppDownload.messages';
import { MobileAppDownloadProps } from './MobileAppDownload.types';

export const MobileAppDownload: FC<MobileAppDownloadProps> = memo((props) => {
    const { number, collapsed, complete } = props;

    return (
        <CollapseSection collapsed={collapsed} complete={complete} number={number} title={messages.title}>
            <Grid gridTemplateColumns='max-content max-content' gap={12}>
                <Text font='body'>
                    {messages.description({
                        br: <br />,
                    })}
                </Text>

                <Grid gridTemplateColumns='auto auto' gap={72}>
                    <Grid justifyItems='center' gap={16}>
                        <GooglePlayQR width={108} height={108} />

                        <Link font='body' external target='_blank' href={appUrls.android}>
                            <GooglePlayLogo />
                        </Link>
                    </Grid>

                    <Grid justifyItems='center' gap={16}>
                        <AppleStoreQR width={108} height={108} />

                        <Link font='body' external target='_blank' href={appUrls.ios}>
                            <AppleStoreLogo />
                        </Link>
                    </Grid>
                </Grid>
            </Grid>
        </CollapseSection>
    );
});

MobileAppDownload.displayName = 'MobileAppDownload';
